import { formatMoney } from "../../lib/format";

const COLS = ["Month", "Portfolio Balance", "Active Loans", "Disbursements", "Principal Collected", "Interest Collected (excl. VAT)"];
const td = "whitespace-nowrap px-4 py-3 text-right tabular-nums";

export const PortfolioTable = ({ months, totals, note }) => (
  <section className="tr-card tr-fade-up overflow-hidden" data-testid="portfolio-table-card">
    <div className="overflow-x-auto" data-testid="portfolio-table-scroll">
      <table className="w-full min-w-[820px] text-sm" data-testid="portfolio-table">
        <thead className="bg-[#f5f8fc] text-xs font-semibold uppercase tracking-wide text-[#5b667a]">
          <tr>
            {COLS.map((c, i) => (
              <th key={c} className={`px-4 py-3 ${i ? "text-right" : "text-left"}`}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-[#eef2f8] text-[#182235]">
          {[...months].reverse().map((m) => (
            <tr key={m.month} className="hover:bg-[#f8fbff]" data-testid={`portfolio-row-${m.month}`}>
              <td className="whitespace-nowrap px-4 py-3 font-semibold">{m.label}</td>
              <td className={td}>{formatMoney(m.balance)}</td>
              <td className={td}>{m.active.toLocaleString("en-US")}</td>
              <td className={td}>{formatMoney(m.disbursements)}</td>
              <td className={td}>{formatMoney(m.principal)}</td>
              <td className={td}>{formatMoney(m.interest)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot className="border-t-2 border-[#dfe7f3] bg-[#f5f8fc] font-extrabold text-[#182235]" data-testid="portfolio-totals">
          <tr>
            <td className="px-4 py-3">Total</td>
            <td className={td} />
            <td className={td} />
            <td className={td} data-testid="total-disbursements">{formatMoney(totals.disbursements)}</td>
            <td className={td} data-testid="total-principal">{formatMoney(totals.principal)}</td>
            <td className={td} data-testid="total-interest">{formatMoney(totals.interest)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <p className="border-t border-[#eef2f8] px-4 py-3 text-xs text-[#5b667a]" data-testid="portfolio-note">{note}</p>
  </section>
);
